<template>
  <div class="classify-wrap">
    <div class="org"></div>
    <div class="classify-list" v-show="navlist.length>0">
      <div
        class="li"
        v-for="item in navlist"
        :key="item.id"
        @click="tocategory(item)"
        :style="{background:item.rgba,color:item.color}"
      >{{item.name}}</div>
    </div>
    <div class="classify-con">
      <div class="smalltag" v-for="(item,ind) in conlist" :key="ind">
        <span class="tags-title">{{item.name}}</span>
        <img src="@/assets/images/ios/classify/rightarrow.png" alt @click="tocategory(item)" />
        <div class="tags">
          <span
            v-for="(items,inds) in item.tags"
            :key="inds"
            @click="tocategory(items)"
          >{{items.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navlist: [], //nav标签
      conlist: [] //下面内容的数据
    };
  },
  created() {
    this.navigation();
    this.getconlist();
  },
  methods: {
    //获取标签数据
    navigation() {
      this.$http
        .get("/apiserv/qTLN2Nec/Frontend/Classify/ios/navigation")
        .then(res => {
          if (res.data.return_code == 200) {
            res.data.data.forEach(i => {
              var msg = i.color;
              var resStr = msg.substr(1);
              var resArr = this.spiltArr(resStr);
              var rgb = this.toTen(resArr);
              i.rgba = "rgb" + "(" + rgb + ",0.1)";
            });
            this.navlist = res.data.data;
          }
        });
    },
    // 获取内容数据
    getconlist() {
      this.$http
        .get("/apiserv/qTLN2Nec/Frontend/Classify/ios/list")
        .then(res => {
          if (res.data.return_code == 200) {
            this.conlist = res.data.data;
          }
        });
    },
    //上边的nav列表条专去分类页
    tocategory(item) {
      var url = item.url + "&title=" + encodeURI(item.name);
      window.webkit.messageHandlers.splitGotoWebPage.postMessage(url);
    },
    //将十进制颜色转为rgb的形式
    spiltArr(str) {
      var tmp = ["", "", ""];
      var strLen = str.length;
      if (strLen == 3) {
        var a = str.substr(0, 1);
        var b = str.substr(1, 1);
        var c = str.substr(2, 1);
        tmp[0] = a + a;
        tmp[1] = b + b;
        tmp[2] = c + c;
        return tmp;
      } else if (strLen == 6) {
        tmp[0] = str.substr(0, 2);
        tmp[1] = str.substr(2, 2);
        tmp[2] = str.substr(4, 2);
        return tmp;
      }
    },
    //将十进制颜色转为rgb的形式
    toTen(arr) {
      var rgb = ["", "", ""];
      for (var i = 0; i < 3; i++) {
        rgb[i] = parseInt(arr[i], 16);
      }
      return rgb;
    }
  }
};
</script>
<style scoped  lang="less">
.classify-wrap {
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  background: #f5f5f5;
  .org {
    width: 100%;
    height: 0.4rem;
    background: linear-gradient(
      90deg,
      rgba(255, 115, 0, 1) 0%,
      rgba(255, 79, 0, 1) 100%
    );
  }
  .classify-list {
    width: 3.5rem;
    margin: 0 0.13rem 0.08rem;
    padding: 0.13rem;
    margin-top: -0.4rem;
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    border-radius: 0.1rem;
    .li {
      width: 0.75rem;
      height: 0.46rem;
      margin-right: 0.08rem;
      margin-top: 0.08rem;
      border-radius: 0.08rem;
      line-height: 0.46rem;
      text-align: center;
      font-size: 0.14rem;
      font-weight: 500;
    }
    .li:nth-of-type(4n + 4) {
      margin-right: 0;
    }
  }
  .classify-con {
    width: 3.5rem;
    margin: 0 0.13rem;
    background: #f5f5f5;
    .smalltag {
      background: #fff;
      border-radius: 0.1rem;
      padding: 0.13rem;
      position: relative;
      margin-bottom: 0.08rem;
      .tags-title {
        height: 0.23rem;
        font-size: 0.17rem;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 0.23rem;
        margin-top: 0.15rem;
      }
      img {
        width: 0.07rem;
        height: 0.14rem;
        position: absolute;
        right: 0.13rem;
        top: 0.18rem;
      }
      .tags {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        span {
          display: block;
          width: 0.75rem;
          height: 0.33rem;
          background: rgba(245, 245, 245, 1);
          border-radius: 0.17rem;
          text-align: center;
          line-height: 0.33rem;
          margin-right: 0.08rem;
          margin-top: 0.08rem;
          font-size: 0.14rem;
          font-weight: 400;
        }
        span:nth-of-type(4n + 4) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>